import { ReactNode } from 'react';
import { useServices } from '@packages/shared/core/common/hooks';

type IsFeatureOffProps = {
  children?: ReactNode;
  name: string;
};

const IsFeatureOff = ({ children, name }: IsFeatureOffProps) => {
  const { featureFlags } = useServices();
  const isFeatureOff = featureFlags.isFeatureOff(name);

  return isFeatureOff ? <>{children}</> : null;
};

export default IsFeatureOff;
